import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { QueryErrorState } from '@/components/admin/shared/QueryErrorState';
import { MODULE_KEY } from '@/constants/modules';
import { useHasWorkspaceModule } from '@/hooks/useHasWorkspaceModule';
import { useWorkspaceCustomDomainsQuery } from '@/api/customDomains/useWorkspaceCustomDomains';
import { CustomDomainAddForm } from './CustomDomainAddForm';
import { CustomDomainCard } from './CustomDomainCard';
import { CustomDomainLockedCard } from './CustomDomainLockedCard';

export function CustomDomainSection() {
  const { t } = useTranslation('customDomains');
  const hasCustomDomainsModule = useHasWorkspaceModule(MODULE_KEY.customDomains);
  const customDomainsQuery = useWorkspaceCustomDomainsQuery(hasCustomDomainsModule);

  if (hasCustomDomainsModule === false) {
    return <CustomDomainLockedCard />;
  }

  if (customDomainsQuery.isLoading === true) {
    return (
      <div className="py-8 flex justify-center">
        <LoadingSpinner className="w-7 h-7" />
      </div>
    );
  }

  if (customDomainsQuery.isError === true || customDomainsQuery.data === undefined) {
    return (
      <QueryErrorState
        onRetry={function retry() {
          customDomainsQuery.refetch();
        }}
      />
    );
  }

  const customDomains = customDomainsQuery.data;

  return (
    <Card padding="md">
      <h2 className="text-sm font-bold text-zooindigo">{t('title')}</h2>
      <p className="text-xs text-zoomuted mt-1 mb-5">{t('subtitle')}</p>

      <CustomDomainAddForm />

      {customDomains.length === 0 ? (
        <p className="mt-5 text-xs text-zoomuted">{t('empty')}</p>
      ) : (
        <div className="mt-5 space-y-4">
          {customDomains.map(function renderCustomDomain(customDomain) {
            return (
              <CustomDomainCard
                key={customDomain.id}
                customDomain={customDomain}
                allCustomDomains={customDomains}
              />
            );
          })}
        </div>
      )}
    </Card>
  );
}
